import React from "react";
import AlertLegalbird from "@/src/components/legalbird/AlertLegalbird/AlertLegalbird";
import AlertContentLegalbird from "@/src/components/legalbird/AlertLegalbird/AlertContentLegalbird";

export default function MessageCenterNoCasesMessage() {
  return (
    <>
      <AlertLegalbird severity={"warning"} sx={{ margin: "2rem 0 1.5rem" }}>
        <AlertContentLegalbird
          subtitle={
            <>
              Sobald Sie einen Fall bei uns haben, können Sie von hier aus ganz bequem direkt mit Ihrem Anwalt kommunizieren. Sie haben vorab z.B. eine Frage
              zum Ablauf? Dann schreiben Sie uns eine E-Mail an <a href={"mailto:service@legalbird.de"}>service@legalbird.de</a>
            </>
          }
        />
      </AlertLegalbird>
    </>
  );
}
